export default "__VITE_ASSET__96c24457__"